import { render, staticRenderFns } from "./SwitchOrganisationView.vue?vue&type=template&id=2b5805d6&scoped=true"
import script from "./SwitchOrganisationView.vue?vue&type=script&lang=js"
export * from "./SwitchOrganisationView.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrganisationView.vue?vue&type=style&index=0&id=2b5805d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5805d6",
  null
  
)

export default component.exports